import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { getNbgPayStore } from '../+state/payment.selectors';
import {
  RedirectPaymentProviderPage,
  SetNbgPayRequestJsonSuccess,
} from '../+state/payment.actions';

@Component({
  selector: 'app-nbgpay',
  templateUrl: './nbgpay.component.html',
  styleUrls: ['./nbgpay.component.scss'],
})
export class NbgpayComponent implements OnInit, OnDestroy {
  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store
      .select(getNbgPayStore)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((nbgPay) => {
        switch (nbgPay?.nbgPayState?.status) {
          case 'SET_REQUEST_JSON':
            this.store.dispatch(new SetNbgPayRequestJsonSuccess());
            break;
          case 'SET_REQUEST_JSON_SUCCESS':
            const requestJSON: any = nbgPay.nbgPayState.requestJSON;
            this.store.dispatch(
              new RedirectPaymentProviderPage(
                requestJSON?.checkoutUrl,
                requestJSON?.paymentFormParams?.callbackUrl,
                requestJSON?.paymentParams?.PAYMENT_REFERENCE,
              ),
            );
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
